import React, { Component } from "react";

import {
  Wrapper,
  Title,
  Card,
  Bold,
  Gradient,
  Copy
} from "app/NativeComponents/common";

import { PillButton } from "app/NativeComponents/snippets";

import { renderPrice, numberWithCommas, openUrl } from "app/NativeActions";

class Plan extends Component {
  constructor(props) {
    super(props);

    this.state = this.determineState(props);
  }

  determineState(props) {
    const selected =
      props.selected_plan &&
      props.plan &&
      props.selected_plan.id == props.plan.id
        ? true
        : false;
    let plan_title = "Basic";
    switch (parseInt(props.plan.tier)) {
      default:
        break;
      case 2:
        plan_title = "Professional";
        break;

      case 3:
        plan_title = "Enterprise";
        break;
    }

    let button_text = "Select Plan";
    if (selected && props.plan.enterprise != 1) {
      button_text = "Selected";
    } else if (props.plan.enterprise == 1) {
      button_text = "Talk To Sales";
    } else if (
      !props.plan_module_info.is_trial_over &&
      props.plan_module_info.slug != "messages"
    ) {
      button_text = "Try For Free";
    }

    return {
      selected,
      plan_title,
      button_text,
      gradient_button_color_1:
        selected && props.plan.enterprise != 1
          ? props.colors.gradient_button_color_1
          : props.colors.card_color,
      gradient_button_color_2:
        selected && props.plan.enterprise != 1
          ? props.colors.gradient_button_color_2
          : props.colors.card_color,
      background_color: selected
        ? props.colors.active_color
        : props.colors.card_color,
      text_color:
        selected && props.plan.enterprise != 1
          ? props.colors.white_text_color
          : props.colors.text_color
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.selected_plan !== prevProps.selected_plan) {
      this.setState(this.determineState(this.props));
    }
  }
  renderEnterpriseSubText() {
    if (
      this.props.plan.module_type != "messages" &&
      this.props.plan.enterprise == 1
    ) {
      return (
        <Copy
          style={{
            textAlign: "center",
            color: this.state.text_color
          }}
        >
          + one-time $1,000 onboarding fee
        </Copy>
      );
    } else {
      return <Wrapper />;
    }
  }
  renderPricing() {
    return (
      <Wrapper>
        <Copy
          style={{
            textAlign: "center",
            color: this.state.text_color
          }}
        >
          Unlock <Bold>{renderPrice(this.props.plan.additional_price)}</Bold>{" "}
          Mailer Pricing
        </Copy>
        <Copy
          style={{
            textAlign: "center",
            color: this.state.text_color
          }}
        >
          Unlock{" "}
          <Bold>{renderPrice(this.props.plan.enhanced_search_price)}</Bold> Skip
          Trace Pricing
        </Copy>
      </Wrapper>
    );
  }

  renderFeatures() {
    switch (this.props.plan.module_type) {
      case "driving":
      default:
        return (
          <Wrapper>
            <Copy
              style={{
                textAlign: "center",
                color: this.state.text_color
              }}
            >
              {" "}
              {numberWithCommas(this.props.plan.number_of_leads)} leads per
              month{" "}
            </Copy>
            <Copy
              style={{
                textAlign: "center",
                color: this.state.text_color
              }}
            >
              {parseInt(this.props.plan.teammate_limit) === -1
                ? "Unlimited Full-Access Users"
                : parseInt(this.props.plan.teammate_limit) === 1
                ? "1 Full-Access User"
                : parseInt(this.props.plan.teammate_limit) +
                  " Full-Access Users"}{" "}
            </Copy>
            <Copy
              style={{
                textAlign: "center",
                color: this.state.text_color
              }}
            >
              {parseInt(this.props.plan.dealfinder_limit) === 1
                ? "1 DealFinder"
                : parseInt(this.props.plan.dealfinder_limit) +
                  " DealFinders"}{" "}
            </Copy>
          </Wrapper>
        );

      case "lists":
        return (
          <Wrapper>
            <Copy
              style={{
                textAlign: "center",
                color: this.state.text_color
              }}
            >
              {this.props.plan.number_of_lists == -1
                ? "Unlimited lists per month"
                : this.props.plan.number_of_lists == 1
                ? "1 list type per month"
                : this.props.plan.number_of_lists + " list types per month"}
            </Copy>

            <Copy
              style={{
                textAlign: "center",
                color: this.state.text_color
              }}
            >
              {parseInt(this.props.plan.teammate_limit) === -1
                ? "Unlimited Full-Access Users"
                : parseInt(this.props.plan.teammate_limit) === 1
                ? "1 Full-Access User"
                : parseInt(this.props.plan.teammate_limit) +
                  " Full-Access Users"}{" "}
            </Copy>
          </Wrapper>
        );
      case "messages":
        return (
          <Wrapper>
            <Copy
              style={{
                textAlign: "center",
                color: this.state.text_color
              }}
            >
              {this.props.plan.number_of_conversations == -1
                ? "Unlimited active conversations"
                : this.props.plan.number_of_conversations == 1
                ? "1 active conversation per month"
                : numberWithCommas(this.props.plan.number_of_conversations) +
                  " active conversations per month"}
            </Copy>

            <Copy
              style={{
                textAlign: "center",
                color: this.state.text_color
              }}
            >
              {this.props.plan.number_of_phone_numbers == -1
                ? "Unlimited local phone numbers"
                : this.props.plan.number_of_phone_numbers * 30 +
                  " local phone numbers"}
            </Copy>
          </Wrapper>
        );
    }
  }

  render() {
    return (
      <Wrapper className="plan-item" style={{ alignSelf: "stretch" }}>
        <Card>
          <Gradient
            style={
              this.props.isMobile
                ? {
                    borderRadius: 5
                  }
                : {
                    borderRadius: 5,
                    flex: 1
                  }
            }
            color1={this.state.gradient_button_color_1}
            color2={this.state.gradient_button_color_2}
          >
            <Wrapper style={{ padding: 20, paddingBottom: 0 }}>
              <Title
                style={{
                  textAlign: "center",
                  color: this.state.text_color
                }}
              >
                {this.state.plan_title}
              </Title>
              <Copy
                style={{
                  textAlign: "center",
                  fontSize: 42,
                  paddingTop: 20,
                  paddingBottom: 20,
                  color: this.state.text_color
                }}
              >
                <Bold>
                  {this.props.frequency === "annually" ||
                  (this.props.plan.enterprise == 1 &&
                    this.props.plan.module_type !== "messages")
                    ? renderPrice(
                        this.props.plan.yearly_cost_cents,
                        "no_decimal"
                      )
                    : renderPrice(
                        this.props.plan.monthly_cost_cents,
                        "no_decimal"
                      )}
                </Bold>
              </Copy>

              <Copy
                style={{
                  textAlign: "center",
                  color: this.state.text_color
                }}
              >
                {this.props.frequency === "annually" ||
                (this.props.plan.enterprise == 1 &&
                  this.props.plan.module_type !== "messages")
                  ? "Per Year"
                  : "Per Month"}
              </Copy>
              {this.renderEnterpriseSubText()}
            </Wrapper>

            <Wrapper
              style={{
                alignItems: "center",
                justifyContent: "center",
                padding: 20,
                paddingTop: 0,
                paddingBottom: 0
              }}
            >
              <PillButton
                onPress={() => {
                  parseInt(this.props.plan.enterprise) === 1
                    ? openUrl("https://dealmachine.com/talk-to-sales")
                    : this.props.selectPlan({
                        selected_plan: this.props.plan,
                        frequency: this.props.frequency
                      });
                }}
                primary={
                  this.props.plan.current_tier == 3 &&
                  this.props.plan.module_type != "messages"
                    ? true
                    : false
                }
              >
                {this.state.button_text}
              </PillButton>
            </Wrapper>

            <Wrapper style={{ padding: 20 }}>
              {this.renderPricing()}
              {this.renderFeatures()}

              {this.props.plan.features
                ? this.props.plan.features.map((item, i) => {
                    return (
                      <Copy
                        key={i}
                        style={{
                          textAlign: "center",
                          color: this.state.text_color
                        }}
                      >
                        {item}
                      </Copy>
                    );
                  })
                : ""}
            </Wrapper>
          </Gradient>
        </Card>
      </Wrapper>
    );
  }
}

export default Plan;
